const num = (v) => Number(v) || 0;

export function toStockValueSeries(categories) {
  const rows = Array.isArray(categories) ? categories : [];
  return {
    labels: rows.map((c) => c.categoryName),
    values: rows.map((c) => num(c.value)),
  };
}

export function toPoStatusSeries(statuses) {
  const rows = Array.isArray(statuses) ? statuses : [];
  return {
    labels: rows.map((s) => s.status),
    counts: rows.map((s) => num(s.count)),
    amounts: rows.map((s) => num(s.amount)),
  };
}

export function toMovementsTrendSeries(months) {
  const rows = Array.isArray(months) ? months : [];
  return {
    labels: rows.map((m) => m.month),
    inbound: rows.map((m) => num(m.inbound)),
    outbound: rows.map((m) => num(m.outbound)),
  };
}

export function toTopProductsSeries(products) {
  const rows = Array.isArray(products) ? products : [];
  return {
    labels: rows.map((p) => p.name),
    values: rows.map((p) => num(p.value)),
  };
}
